import * as Styled from './footer-subjects-placeholder.style';

export const FooterSubjectsPlaceholder = ({
  numberOfSubjects,
}: {
  numberOfSubjects: number;
}) => (
  <>
    {Array.from({ length: numberOfSubjects }, (_, index) => (
      <Styled.FooterSubjectsPlaceholderListItem key={index}>
        <Styled.FooterSubjectsPlaceholderLink />
      </Styled.FooterSubjectsPlaceholderListItem>
    ))}
  </>
);
